import { render, staticRenderFns } from "./WebinarDetails.vue?vue&type=template&id=3b621d06&scoped=true&"
import script from "./WebinarDetails.vue?vue&type=script&lang=js&"
export * from "./WebinarDetails.vue?vue&type=script&lang=js&"
import style0 from "./WebinarDetails.vue?vue&type=style&index=0&id=3b621d06&scoped=true&lang=scss&"
import style1 from "./WebinarDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b621d06",
  null
  
)

component.options.__file = "WebinarDetails.vue"
export default component.exports